import React from 'react';
import styled from '@emotion/styled';

import StatusBadge from '../common/StatusBadge';

import { SUPPLY_STATUS_TRANSLATE } from '../../config';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Badge = styled('div')`
  position: relative;
  display: inline-block;
  font-size: 10px;
  line-height: 1;
  padding: 0.25em 0.4em;
  border-radius: 0.25rem;
  font-weight: bold;
  background: #ccc;
  border: 1px solid #fff;
  color: #296775;
  margin: 0 10px;
`;

const STATUS_STYLES = {
  DRAFT: {
    background: '#eceff1',
    color: '#343a40',
  },
  NEW: {
    background: '#6c757d',
    color: '#fff',
  },
  READY_TO_TAKE_IN: {
    background: '#4fc6e1',
    color: '#fff',
  },
  TAKE_IN_PROCESS: {
    background: '#f7b84b',
    color: '#fff',
  },
  COMPLETED: {
    background: '#1abc9c',
    color: '#fff',
  },
  COMPLETED_WITH_DIFFERENCE: {
    background: '#1abc9c',
    color: '#fff',
  },
  CANCELED: {
    background: '#f1556c',
    color: '#fff',
  },
  DIFFERENCE: {
    background: '#f1556c',
    color: '#fff',
  },
};

const SupplyStatus = (props) => {
  const { t } = useAutoTranslation();
  return (
    <>
      <StatusBadge
        {...props}
        translateData={SUPPLY_STATUS_TRANSLATE}
        stylesData={STATUS_STYLES}
        t={t}
      />
      {props.checkRelatedOrders ? (
        <Badge
          style={{
            background: '#E1A142',
            color: '#fff',
          }}
        >
          <span>
            <i className="fe-link"></i>
            {t('Связанные заказы')}
          </span>
        </Badge>
      ) : null}
    </>
  );
};

export default SupplyStatus;
